import * as React from 'react';

function SvgEmail(props) {
  return (
    <svg
      viewBox="0 -100 512 512"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        d="M512 17.469v276.453c0 9.629-7.84 17.465-17.469 17.465H17.47C7.839 311.387 0 303.55 0 293.922V17.469C0 7.839 7.84 0 17.469 0H494.53C504.161 0 512 7.84 512 17.469zm0 0"
        fill="#ff9468"
      />
      <path
        d="M512 17.469v276.453c0 9.629-7.84 17.465-17.469 17.465H256V0h238.531C504.161 0 512 7.84 512 17.469zm0 0"
        fill="#ff712f"
      />
      <path
        d="M512 289.484v4.438c0 9.629-7.84 17.465-17.469 17.465H17.47C7.839 311.387 0 303.55 0 293.922v-4.438l185.094-161.129h141.812zm0 0"
        fill="#ff5b5b"
      />
      <path
        d="M512 289.484v4.438c0 9.629-7.84 17.465-17.469 17.465H256V128.355h70.906zm0 0"
        fill="#ff3636"
      />
      <path
        d="M494.531 0H17.47C7.839 0 0 7.84 0 17.469v6.304l246.328 163.024a17.494 17.494 0 009.66 2.922H256c3.375 0 6.746-.98 9.7-2.942L512 22.184v-4.715C512 7.839 504.16 0 494.531 0zm0 0"
        fill="#ffb64c"
      />
      <path
        d="M512 17.469v4.715L265.7 186.777a17.502 17.502 0 01-9.7 2.942V0h238.531C504.161 0 512 7.84 512 17.469zm0 0"
        fill="#ff9f00"
      />
    </svg>
  );
}

export default SvgEmail;
